import { combineReducers } from 'redux';
import { terms } from './terms';
import { privacypolicies } from './privacypolicy';
import { termsPrivacyHistory } from './termsPrivacyHistory';
import { supportLanguages } from './supportLanguages';

export default combineReducers({ terms, privacypolicies, termsPrivacyHistory, supportLanguages });
